/*global define*/

define("models/Vessel", [
    'underscore',
    'backbone',
    'resources/vessels',
    'chemistry/Solution',
    'resources/lang'
], function (_, Backbone, vesselInfo, Solution, lang) {
    'use strict';

    var VesselModel = Backbone.Model.extend({
        defaults: {
            pour: false,
            // color: "lightblue",
            solidColor: "white",
            volume: 0,
            solidVolume: 0,
            name: "default name",
            temperature: 273.15,
            pH: 7,
            draggable: true // Add draggable as default...
        },
        events: {
            "destroy": "destroyCalled"
        },
        initialize: function(solutionData, vesselData){
            // Get the information from the solution
            this.set('vessel', vesselData);
            this.set('solution', solutionData);
            if (vesselData) {
                this.set('emptyWeight', vesselData.weight + Math.random() * vesselData.weightVariation);
            }

            if (solutionData === null){
                this.set("name", vesselData.name);
            }

                else{

                 this.set('category', solutionData.category);
                 this.set('description', solutionData.description);
                 this.set('name', solutionData.name);
                 this.set('index', solutionData.index);
                 this.set('simpleName', solutionData.simpleName);
                 this.set('pour', false);
                 this.set('accept', false);
                 this.set('hasTool', false);
                 var sol1 = new Solution(solutionData);
                 sol1.container = this;
                 sol1.initialize();
                 if (vesselData.name === "Foam Cup") {
                     sol1.setInsulated(true);
                 }
                 this.set('solution',sol1);
                 this.set('volume', sol1.getVolume());
                 this.set('solidVolume', sol1.getSolidVolume());
                 this.set('species', sol1.getSpeciesData() );
                 this.set('pH', sol1.getPH());
                 this.set('conductivity', sol1.getConductivity());  
                 this.set('temperature', sol1.getTemperature());
                 this.set('color', sol1.getColor());
                 this.set('solidColor', sol1.getSolidColor());
                 this.set('log', [["Time (s)", lang.solutionProperties.volume[language]+" (L)", lang.solutionProperties.temperature[language]+" (K)", "pH"]]);
                 this.set('colors', sol1.colors);
                 this.set('absorbanceTable', sol1.getAbsorbanceTable());
                 this.set('t0', new Date().getTime());
                 this.recordProperties();
                 this.set('timedTracking', false);
                 this.set('pourTracking', false);
                 this.set('origin', solutionData.origin);
                 this.set('honorSignificantFigures', solutionData.honorSignificantFigures);
                 this.setVolumeString();
       }
        },
        destroyCalled: function(){
        },
        removeVolume: function(vol){
            var volume = this.get("volume");
            var solidVolume = this.get("solidVolume");
            if (vol  > volume - solidVolume) {
                this.set("volume", volume - vol);
                this.set("solidVolume", volume - vol);
            }
            else {
                this.set("volume", volume - vol);
            }
            this.setVolumeString();

            if (this.get('pourTracking')) {
                this.recordProperties();
            }
        },
        addSolution: function(vesselSource, amount)
        {
            var volume = parseFloat(this.get("volume"));
            //this.set("volume", volume+amount);
            var source = vesselSource.get('solution');
            var sol1 = this.get('solution');
            sol1.mix(source,amount);
            this.set('solution', sol1);
            this.set("volume", sol1.getVolume());
            this.set("solidVolume", sol1.getSolidVolume());
            this.set('species', sol1.getSpeciesData() );
            this.set('pH', sol1.getPH());
            this.set('conductivity', sol1.getConductivity());
            this.set('temperature', sol1.getTemperature());
            this.set('color', sol1.getColor());
            this.set('solidColor', sol1.getSolidColor());
            this.set('colors', sol1.colors);
            this.set('absorbanceTable', sol1.getAbsorbanceTable());
            this.setVolumeString();

            if (this.get('pourTracking')) {
                this.recordProperties();
            }
        },
        recordProperties: function(){
            
            var log = this.get("log");
            const t0 = this.get('t0');
            const t = (new Date().getTime() - t0) / 1000;
            var entry = [t, this.get("volume"), this.get("temperature"), this.get("pH")];
            var species = this.get("species");
            var i;
            for (i = 0; i < species.length; i++) {
                if (log[0].indexOf(species[i].simpleName) === -1) {
                    log[0][log[0].length] = species[i].simpleName;
                    if (species[i].unknown) {
                        entry[log[0].length - 1] = "unknown";
                    }
                    else {
                        entry[log[0].length - 1] = species[i].amount;
                    }
                }
                else {
                    if (species[i].unknown) {
                        entry[log[0].indexOf(species[i].simpleName)] = "unknown";
                    }
                    else {
                        entry[log[0].indexOf(species[i].simpleName)] = species[i].amount;
                    }
                }
            }
            log.push(entry);
            this.set("log", log);
        },
        getWeight: function(){
            var solution = this.get("solution");
            if (solution === null) {
                return this.get("emptyWeight");
            }
            return solution.getSolutionWeight() + this.get("emptyWeight");
        },
        setVolumeString: function() {
            var v = this.get("volume") * 1000;
            var volumeStr = "";
            if (this.get("honorSignificantFigures")) {
                var r = this.get("vessel").roundoffTolerance * 1000;
                var e = Math.ceil(Math.log(r) / Math.log(10));

                if (e > -1) {
                    v /= Math.pow(10, e);
                    v = Math.round(v);
                    v *= Math.pow(10, e);

                    volumeStr = "~" + parseInt(v).toLocaleString(language, {useGrouping: false}) + " mL";
                }
                else {
                    v *= Math.pow(10, Math.abs(e));
                    v = Math.round(v);
                    v /= Math.pow(10, Math.abs(e));

                    var vString = v.toLocaleString(language, {useGrouping: false});
                    if (vString.indexOf(".") !== -1)
                        while (vString.length - vString.indexOf(".") - 1 < Math.abs(e))
                            vString += "0";
                    else if (vString.indexOf(",") !== -1)
                        while (vString.length - vString.indexOf(",") - 1 < Math.abs(e))
                            vString += "0";

                    volumeStr = "~" + vString + " mL";
                }
            }
            else
                volumeStr = parseFloat(v).toLocaleString(language, {maximumSignificantDigits: 5, minimumSignificantDigits: 5, useGrouping: false}) + " mL";
            this.set("volumeString", volumeStr);
        }
    });

    return VesselModel;
});
